import { useEffect, useMemo, useRef, useState } from 'react';
import Chart from 'chart.js/auto';
import regularAppService from '../../services/regularAppService';

function CustomerOrdersSparkline({ customerId }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    let active = true;
    async function load() {
      try {
        const page = await regularAppService.getPaginated({
          collection: 'orders',
          page: 1,
          limit: 500,
          filter: { customerId },
          sortBy: 'orderDate',
          sortOrder: 'asc',
        });
        if (!active) return;
        setOrders(Array.isArray(page?.items) ? page.items : []);
      } catch (e) {
        if (!active) return;
        setOrders([]);
      }
    }
    if (customerId) load();
    return () => { active = false; };
  }, [customerId]);

  const chartData = useMemo(() => {
    const map = new Map();
    for (const o of orders) {
      const d = o?.orderDate ? new Date(o.orderDate) : (o?.createdAt ? new Date(o.createdAt) : null);
      if (!d) continue;
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const key = `${y}-${m}-${day}`;
      map.set(key, (map.get(key) || 0) + 1);
    }
    const labels = Array.from(map.keys()).sort();
    const data = labels.map((k) => map.get(k));
    return { labels, datasets: [{
      label: 'Órdenes',
      data,
      borderColor: '#33a02c',
      backgroundColor: 'rgba(51, 160, 44, 0.2)',
      tension: 0.3,
      borderWidth: 1,
      pointRadius: 0,
      pointHitRadius: 8,
      hoverRadius: 3,
    }] };
  }, [orders]);

  useEffect(() => {
    const ctx = canvasRef.current?.getContext('2d');
    if (!ctx) return;
    if (chartRef.current) chartRef.current.destroy();
    const isEmpty = !chartData.labels?.length;
    chartRef.current = new Chart(ctx, {
      type: 'line',
      data: isEmpty ? { labels: [''], datasets: [] } : chartData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false }, tooltip: { enabled: true } },
        interaction: { mode: 'index', intersect: false },
        scales: {
          x: { display: true, ticks: { maxTicksLimit: 6 }, grid: { display: false } },
          y: { display: false },
        },
        elements: { line: { fill: false } },
      },
    });
    return () => { if (chartRef.current) chartRef.current.destroy(); };
  }, [chartData]);

  return (
    <div style={{ width: '100%', height: 60 }}>
      <canvas ref={canvasRef} />
    </div>
  );
}

export default CustomerOrdersSparkline;
